controllers.controller('UploadDocumentsController', [
    '$scope', '$state', 'LocaleService', 'constants', '$ionicLoading', 'UserService', 'UserControl',
    function ($scope, $state, LocaleService, Const, $ionicLoading, UserService, UserControl) {

        LocaleService.wait().then(function (translation) {
            $scope.translation = translation;
            $scope.lang = LocaleService.lang;
        });

        $scope.lang = LocaleService.lang;
        $scope.user = UserService.get();
        $scope.categories = Const.documentCategories;

        $ionicLoading.hide();

        $scope.navigate = function (state, params) {
            return params.category.name === 'document_other' ?
                $state.go('root.app.uploadDocumentsOther') :
                $state.go(state, {
                    categoryName: params.category.name,
                    categoryVideoLink: params.category.videoLinks && (params.category.videoLinks[$scope.lang] || params.category.videoLinks['en']),
                });
        };

        $scope.$on('$ionicView.beforeEnter', function () {
            $scope.state = UserControl.getState();
            if ($scope.state) {
                return $state.go($scope.state, {cache: false});
            }

            if ($scope.user && !$scope.user.tnc && Const['tncPopup']) {
                return $state.go('tnc', {cache: false});
            }
            if ($scope.user) {
                switch ($scope.user.registrationState) {
                    case Const.userState.initial:
                        return $state.go('signupPersonalProfile', {cache: false});
                    case Const.userState.personal:
                        return $state.go('signupQuestionnaire', {cache: false});
                }
            }
        });

    }]);
